import React from "react";
import DocSections from "@/pages/DocSections";

export default function StaffManual() {
  return (
    <DocSections
      title="Staff Manual"
      subtitle="Everything coaches need — sign to acknowledge"
      endpoint="/staff-manual"
      ackable
      testid="staff-manual-page"
    />
  );
}
